module.exports = __webpack_public_path__ + "img/ac.ace104704.svg";